import {createRoot, hydrateRoot} from 'react-dom/client';
import DentalMyths from '../pages/DentalMyths/DentalMyths'
import "../index.css";
import "../pages/DentalMyths/DentalMyths.module.css"

type AnyProps = Record<string, any>;

let root:
   | ReturnType<typeof createRoot>
    | ReturnType<typeof hydrateRoot>
        | null = null;

function mount(el: HTMLElement, props: AnyProps = {}) {
console.log("Rendering......")
root = createRoot(el);
root.render(<DentalMyths {...(props as any)}/>);
}

function hydrate(el: HTMLElement, props: AnyProps = {}) {
console.log("Hydrating......")
root = hydrateRoot(el, <DentalMyths {...(props as any)}/>);
}

function unmount() {
root?.unmount?.();
root = null;
}

if (typeof window !== 'undefined') (window as any).DentalMythsVC = {mount, hydrate, unmount}